<template>
  <v-dialog
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="selectLayerDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">Opprett/rediger tegnelag</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <v-radio-group v-model="useExistingLayer" :mandatory="false">
          <v-radio
            label="Rediger eksisterende tegnelag"
            :value="true"
            color="red"
          ></v-radio>
          <v-radio
            label="Opprett nytt tegnelag"
            :value="false"
            color="red"
          ></v-radio>
        </v-radio-group>
        <v-select
          box
          no-data-text="Det finnes ingen tegnelag"
          label="Velg tegnelag"
          v-if="useExistingLayer"
          :return-object="true"
          :items="allAddedGraphicLayers"
          item-text="appTitle"
          v-model="selectedMapProfile"
        ></v-select>
        <v-text-field
          label="Gi tegnelaget et navn (obligatorisk)"
          v-if="!useExistingLayer"
          v-model="layerTitle"
          box
          full-width
          maxlength="100"
        ></v-text-field>
        <v-textarea
          label="Beskrivelse (valgfritt)"
          v-if="!useExistingLayer"
          v-model="layerDescription"
          maxlength="500"
          box
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" flat @click="cancelDialog">Avbryt</v-btn>
        <v-btn
          color="primary"
          flat
          :disabled="
            (!useExistingLayer && !layerTitle) ||
              (useExistingLayer && !selectedMapProfile)
          "
          @click="loadExistingLayerOrAddNew"
          >Ok</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MappingMixin from "@/mixins/mappingMixin";
import { loadModules } from "esri-loader";
export default {
  name: "MapDrawingAddOrEditDrawingLayerDialog",
  data: function() {
    return {
      selectLayerDialog: false,
      newLayerTitle: "",
      newLayerDescription: "",
      useExistingLayer: false,
      layerTitle: null,
      layerDescription: null,
      graphicsLayer: null
    };
  },
  mixins: [MappingMixin],
  mounted: function() {
    this.openDialog();
  },
  computed: {
    ...mapState(["mapProfiles"]),
    selectedMapProfile: {
      set(selectedMapProfile) {
        this.setSelectedMapProfile(selectedMapProfile);
      },
      get() {
        return this.$store.state.selectedMapProfile;
      }
    }
  },
  methods: {
    ...mapActions([
      "addGraphicsLayer",
      "updateMapProfileName",
      "updateMapProfileDescription",
      "setShowPopupsOnClick",
      "setSelectedMapProfile",
      "deactivateTool"
    ]),
    openDialog: function() {
      this.allAddedGraphicLayers = this.mapProfiles.filter(profile => {
        return profile.type === "graphicsLayer";
      });
      this.selectLayerDialog = true;
    },
    closeDialog: function() {
      this.selectLayerDialog = false;
    },
    cancelDialog: function() {
      this.deactivateTool("drawing");
      this.closeDialog();
    },
    loadExistingLayerOrAddNew: function() {
      if (this.selectedMapProfile) {
        this.loadExistingGraphicsLayer();
      } else {
        this.addNewGraphicsLayer();
      }
    },
    addNewGraphicsLayer: function() {
      loadModules(["esri/layers/GraphicsLayer"]).then(([GraphicsLayer]) => {
        let id = new Date().getTime().toString();
        this.graphicsLayer = new GraphicsLayer({
          id: id
        });
        this.$theMapObject.add(this.graphicsLayer);
        this.addGraphicsLayer(id);
        let newMapProfile = {
          id: id,
          showInfoMenu: false,
          appTitle: this.layerTitle,
          Temaforklaring: this.layerDescription
        };
        this.addMapProfile(newMapProfile);

        this.setSelectedMapProfile(newMapProfile);
        this.$emit("start-drawing", this.graphicsLayer);
        this.closeDialog();
      });
    },
    loadExistingGraphicsLayer: function() {
      this.graphicsLayer = this.$theMapObject.findLayerById(
        this.selectedMapProfile.id
      );
      this.layerTitle = this.selectedMapProfile.appTitle;
      this.layerDescription = this.selectedMapProfile.Temaforklaring;
      this.$emit("start-drawing", this.graphicsLayer);
      this.closeDialog();
    }
  }
};
</script>

<style></style>
